export default "__VITE_ASSET__BVTMeLdz__"